var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Comms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49 1.5c.292 0 .581.112.776.385l1.546 2.171c.18.252.287.458.287.647 0 .236-.176.422-.4.645l-.71.721c.195 1.288.985 2.231 1.836 3.091.765.765 1.604 1.478 2.088 1.76l1.667-.578c.248-.243.447-.448.71-.448.187 0 .392.1.646.286l2.179 1.554c.27.193.385.468.385.753 0 .39-.18.757-.483 1.095-.575.644-1.303.918-2.117.918-2.065 0-4.568-1.645-6.666-3.75C3.137 8.66 1.5 6.164 1.5 4.1c0-.81.275-1.547.911-2.132.328-.305.693-.468 1.08-.468z",
    stroke: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Comms);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-comms.de6db245.svg";
export { ForwardRef as ReactComponent };